import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/_services/auth.service';
import { CompanyService } from 'src/app/_services/company.service';
import { Company } from 'src/models/company.model';
import { PopupDeleteComponent } from '../../informes/descargas/delete-popup.component';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
declare var $;

@Component({
  selector: 'edit-user-popup',
  templateUrl: './edit-user-popup.component.html',
  styles: [],
})
export class PopupEditUserComponent implements OnInit {
  companies: Company[] = [];
  user: any;
  currentCompany: any;
  isSinglar: boolean;
  isSuperAdmin: boolean;
  departments: any;
  roles: any;
  isAccount: boolean = false;
  isMicrosoftAccount: boolean = false;
  isCompanyAdmin: boolean = false;
  isLoading: boolean = false;

  duplicateUserNameError = false;
  duplicateEmailError = false;

  protected ngbModalRef: NgbModalRef;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    public bsModalRef: BsModalRef,
    private modalService: NgbModal,
    private authService: AuthService,
    private msalService: MsalService,
    private router: Router,
    public toastrService: ToastrService,
    public translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.msalService.instance.getActiveAccount() != null) {
      this.isMicrosoftAccount = true;
    }
    this.currentCompany === 1000
      ? (this.isSinglar = true)
      : (this.isSinglar = false);
    this.authService.isSuperAdmin().subscribe((res) => {
      this.isSuperAdmin = !!res;
    });
    this.authService.isAdmin().subscribe((res) => {
      this.isCompanyAdmin = !!res;
    });
    this.companyService
      .getDepartmentsByCompany(this.user.idCompany)
      .subscribe((res) => {
        this.departments = res.body.filter((n) => n);
      });
    this.companyService.getRoles().subscribe((res) => {
      this.roles = res.body;
    });
    window.console.log('editing user: ', this.user);
    window.console.log(this.companies);
  }

  save() {
    this.isLoading = true;
    const entity = {
      ...this.user,
      roleId: this.user.idRolUser,
      companyId: this.user.idCompany,
      statusId: this.user.idStatus,
    };

    this.authService.updateUser(this.user.id, entity).subscribe(
      (res) => {
        this.isLoading = false;
        this.toastrService.success(
          this.translateService.instant('alert.successEdit')
        );
        this.activeModal.close(entity);
      },
      (error) => {
        this.isLoading = false;
        this.toastrService.error(this.translateService.instant('alert.error'));
        console.log(error);
        console.log(error === 'duplicate userName');
        if (error === 'duplicate userName') {
          this.duplicateUserNameError = true;
        }

        if (error === 'duplicate email') {
          this.duplicateEmailError = true;
        }
      }
    );
  }

  changeUserName() {
    this.duplicateUserNameError = false;
  }

  changeEmail() {
    this.duplicateEmailError = false;
  }

  setCompany(e) {
    this.user['idCompany'] = parseInt(e.target.value);
  }

  companyChanged(event) {
    this.companyService.getDepartmentsByCompany(event).subscribe((res) => {
      this.departments = res.body.filter((n) => n);
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }

  resetUserPassword() {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isResetPassword = true;
    this.ngbModalRef.componentInstance.user = this.user;
    this.ngbModalRef.result.then(
      (result) => {
        this.authService.forgotPassword(this.user.email).subscribe((res) => {
          if (localStorage.getItem('id') === this.user.id) {
            window.console.log('email enviado a ', this.user.email);
            this.authService.logout();
            this.router.navigate(['/']);
            this.activeModal.dismiss();
            this.toastrService.success(
              'Se ha enviado un email a su correo para reiniciar su contraseña.'
            );
          } else {
            window.console.log('email enviado a ', this.user.email);
          }
        });
      },
      (err) => {
        window.console.log('err');
      }
    );
  }
}
